import { useAuth } from "@/lib/auth";

const GoogleGlyph = ({ className = "h-4 w-4" }: { className?: string }) => (
  <svg viewBox="0 0 24 24" className={className} aria-hidden="true">
    <path fill="#EA4335" d="M12 10.2v3.9h5.5c-.2 1.3-1.5 3.8-5.5 3.8-3.3 0-6-2.7-6-6.1s2.7-6.1 6-6.1c1.9 0 3.1.8 3.9 1.5l2.6-2.5C16.9 3.1 14.7 2 12 2 6.5 2 2 6.5 2 12s4.5 10 10 10c5.8 0 9.6-4.1 9.6-9.8 0-.7-.1-1.2-.2-1.7H12z" />
  </svg>
);

interface Props {
  returnTo?: string;
  label?: string;
  className?: string;
  testId?: string;
}

export default function GoogleSignInButton({ returnTo, label = "Continue with Google", className = "", testId = "google-signin-button" }: Props) {
  const { signIn } = useAuth();
  return (
    <button
      type="button"
      onClick={() => signIn(returnTo)}
      data-testid={testId}
      className={`inline-flex items-center justify-center gap-3 border border-white/20 bg-white px-6 py-3 font-display text-[11px] font-semibold uppercase tracking-[0.18em] text-obsidian transition-colors duration-300 hover:bg-gold ${className}`}
    >
      <GoogleGlyph />
      {label}
    </button>
  );
}
